import { Icon24Send, Icon24SmileOutline } from '@vkontakte/icons';
import { Button, Flex } from '@vkontakte/vkui';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';

import styles from './styles.module.css';

interface Props {
  showSendButton: boolean;
  onToggleEmojiPanel: () => void;
}

export const WidgetEditorRightPanel = ({ showSendButton, onToggleEmojiPanel }: Props) => {
  return (
    <Flex noWrap>
      <Button
        type="button"
        mode="tertiary"
        data-emoji-panel-trigger
        onClick={onToggleEmojiPanel}
        before={<Icon24SmileOutline fill={baseTheme.colorIconSecondary.normal} />}
      />

      {showSendButton && (
        <Button mode="tertiary" type="submit" before={<Icon24Send className={styles.sendButtonIcon} />} />
      )}
    </Flex>
  );
};
